/**
 * @description Список нарушений.
 * @constructor
 */
function ViolationList() {
  /**
   * @description Список нарушений.
   * @var {any[]}
   */
  const list = [];
  /**
   * @description Добавить нарушение
   * @param {string} name        Название.
   * @param {string} description Описание нарушения.
   * @returns {ViolationList}
   */
  this.push = (name, description) => {
    list.push({ name, description });
    return this;
  };
  /**
   * @description Получить список нарушений.
   * @returns {any}
   */
  this.getCauses = () => {
    const causes = {};
    list.forEach((cause) => {
      const { name, description } = { ...cause };
      causes[name] = causes[name] ? [...causes[name], description] : [description];
    });
    return causes;
  };
  /**
   * @description Имеет нарушения.
   * @returns {boolean}
   */
  this.hasCauses = () => list.length > 0;
}

export default ViolationList;
